import {CollateralService} from "./service/CollateralService";
import {CollateralLodgingService} from "./service/CollateralLodgingService";
import {LodgeAmountService} from "./service/lodge-amount/LodgeAmountService";
import {unlodgedCollateralComponent, UnlodgedCollateralComponent} from "./lodge/unlodged/UnlodgedCollateralComponent";
import {
    lodgedSpecificCollateral,
    LodgedSpecificCollateral
} from "./lodge/lodged-specific/LodgedSpecificCollateralComponent";
import {
    lodgedGeneralCollateral,
    LodgedGeneralCollateral
} from "./lodge/lodged-general/LodgedGeneralCollateralComponent";
import {
    pendingLodgementIndicator,
    PendingLodgementIndicator
} from "./pending-lodgement-indicator/PendingLodgementIndicator";

export default angular.module("tfApp.portfolio.collateral", [])
                      .service(CollateralService.id, CollateralService)
                      .service(CollateralLodgingService.id, CollateralLodgingService)
                      .service(LodgeAmountService.id, LodgeAmountService)
                      .component(UnlodgedCollateralComponent, unlodgedCollateralComponent())
                      .component(LodgedSpecificCollateral, lodgedSpecificCollateral())
                      .component(LodgedGeneralCollateral, lodgedGeneralCollateral())
                      .component(PendingLodgementIndicator, pendingLodgementIndicator())
                      .name;
